module.exports = __webpack_public_path__ + "static/media/Clair de Lune.897d59b6.png";